export enum VehicleUsage {
  SELECT_USAGE = 'Select Vehicle Usage',
  PRIVATE_AND_PROFESSIONAL= 'Private and Professional',
  BUSINESS= 'Business',
  COMMERCIAL= 'Commercial'
}
